module.exports = __webpack_public_path__ + "img/news_img.1fb43f99.jpg";